// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"UKLoadingIcon_loadingIcon__vQFEb","spin":"UKLoadingIcon_spin__V3kHN"};